import { localTokenFactory } from '../types/src/local-token-factory'

export const localToken = localTokenFactory('@dandi/core')
